import _ from 'lodash'
import moment from 'moment'
import md5 from 'js-md5'

// String Formatting

export const camelify = (str) => {
  return str.toLowerCase().replace(/^\w|\s\w/g, (letter) => {
    return letter.toUpperCase()
  })
}

export const kebabify = (str) => {
  if (str) {
    str = str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
  }
  return str
}

export const snakify = (str) => {
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
}

export const slugify = (str) => {
  return str.replace(/ /g, '_')
}

export const unslugify = (str) => {
  return _.startCase(str)
}

export const truncate = (str, n = 30) => {
  if (str && str.length > n) {
    str = str.slice(0, n - 3) + '...'
  }
  return str
}

// Number Formatting

export const formatNumber = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const round = (x, n = 2) => {
  return x !== '-' ? Number(x).toFixed(n) : x
}

export const formatSize = (size) => {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
}

// Date Formatting

export const formatDate = (value, formatType, customFormat) => {
  const format = customFormat || 'dddd, MMM DD YYYY - HH:mm A'
  if (formatType === 'calendar') {
    value = moment(value).calendar(null, { sameElse: format })
  }
  if (formatType === 'date') {
    value = moment(value).format(format)
  }
  if (value === 'Invalid date') {
    value = '-'
  }
  return value
}

// Objects helper

export const contains = (list, searchItem, field) => {
  /*
    In Javascript, Objects comparison are made by reference and not by values.
    So a function like Array.includes(Object) doesn't work.

    Ex:
    contains([{a: 2}, {a: 1}], {a: 1}, 'a')     // true
    contains([{a: 2}, {a: 1}], {a: 4}, 'a')     // false
    contains([{a: 2}, {a: 1}], {}, 'a')         // false
    contains([{a: 2}, {a: 1}], undefined, 'a')  // false
    contains([{a: 2}, {a: 1}], {a: 1}, 'b')     // false
  */
  return !!searchItem && list.some(item => {
    return field in item && item[field] === searchItem[field]
  })
}

export const remove = (list, searchItem, field) => {
  return !!searchItem && list && list.length && list.filter(item => {
    return (
      !(field in item) ||
      !(field in searchItem) ||
      item[field] !== searchItem[field]
    )
  })
}

// Custom getter and setter

export const get = (model, field, defaultValue = '-', formatType = '') => {
  let value
  if (typeof field === 'function') {
    try {
      value = field(model) || defaultValue
    } catch (error) {
      value = defaultValue
    }
  } else {
    value = _.get(model, field, defaultValue)
  }
  value = formatDate(value, formatType)
  return value
}

export const set = _.set

// Profile URL helper

export const profileUrl = (user) => {
  const userInitials = (
    user.first_name && user.last_name
      ? `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`
      : `${user.email.charAt(0)}${user.email.charAt(1)}`
  ) || '01'
  const defaultImage = `https://cdn.auth0.com/avatars/${userInitials.toLowerCase()}.png`
  const hashedEmail = md5(user.email.toLowerCase())
  return `https://www.gravatar.com/avatar/${hashedEmail}?d=${defaultImage}`
}

// Export all methods

export default {
  camelify,
  kebabify,
  snakify,
  slugify,
  truncate,
  unslugify,
  formatNumber,
  round,
  formatSize,
  formatDate,
  contains,
  remove,
  get,
  set,
  profileUrl
}
